import React from 'react';
import { TypedMemo } from '../../../common/types';
import styles from './ChartSkeleton.module.scss';

const ChartSkeletonComponent: React.FC = () => {
  return (
    <div className={styles.container}>
      {/* Y-axis labels */}
      <div className={styles.yAxis}>
        <div className={styles.axisLabel} />
        <div className={styles.axisLabel} />
        <div className={styles.axisLabel} />
        <div className={styles.axisLabel} />
      </div>

      {/* Chart area with bars/lines */}
      <div className={styles.chartArea}>
        <div className={styles.gridLines}>
          <div className={styles.gridLine} />
          <div className={styles.gridLine} />
          <div className={styles.gridLine} />
          <div className={styles.gridLine} />
        </div>

        <div className={styles.bars}>
          <div className={styles.bar} style={{ height: '60%' }} />
          <div className={styles.bar} style={{ height: '85%' }} />
          <div className={styles.bar} style={{ height: '45%' }} />
          <div className={styles.bar} style={{ height: '70%' }} />
          <div className={styles.bar} style={{ height: '55%' }} />
          <div className={styles.bar} style={{ height: '90%' }} />
          <div className={styles.bar} style={{ height: '40%' }} />
        </div>
      </div>
    </div>
  );
};

export const ChartSkeleton = TypedMemo(ChartSkeletonComponent);
